import styled from "@emotion/styled";
import { Typography } from "@mui/material";

const Typo = styled(Typography)``;

export default Typo;
